import React from 'react';
import PropTypes from 'prop-types';

import ZPAR from '../assets/logos/zonaprop.svg';
import I2MX from '../assets/logos/inmuebles24.svg';
import DVPE from '../assets/logos/adondevivir.svg';
import UBPE from '../assets/logos/urbania.svg';
import LLVE from '../assets/logos/conlallave.svg';
import PLEC from '../assets/logos/plusvalia.svg';
import CAPA from '../assets/logos/compreoalquile.svg';
import IWBR from '../assets/logos/imovelweb.svg';
import WIBR from '../assets/logos/wimoveis.svg';
import CMBR from '../assets/logos/casa-mineira.svg';
import VAMX from '../assets/logos/vivanuncios.svg';
import QA from '../assets/logos/quinto-andar.svg';

// TODO: Check incoming props
import ZPARMobile from '../assets/logos/zonaprop_mobile.svg';
import I2MXMobile from '../assets/logos/inmuebles24_mobile.svg';
import DVPEMobile from '../assets/logos/adondevivir_mobile.svg';
import UBPEMobile from '../assets/logos/urbania_mobile.svg';
import LLVEMobile from '../assets/logos/conlallave_mobile.svg';
import PLECMobile from '../assets/logos/plusvalia_mobile.svg';
import CAPAMobile from '../assets/logos/compreoalquile_mobile.svg';
import IWBRMobile from '../assets/logos/imovelweb_mobile.svg';
import WIBRMobile from '../assets/logos/wimoveis_mobile.svg';
import CMBRMobile from '../assets/logos/casa-mineira_mobile.svg';
import VAMXMobile from '../assets/logos/vivanuncios_mobile.svg';

const source = {
  ZPAR,
  DVPE,
  UBPE,
  LLVE,
  PLEC,
  CAPA,
  IWBR,
  WIBR,
  '24MX': I2MX,
  CMBR,
  VAMX,
  QA,
  mobile: {
    ZPAR: ZPARMobile,
    DVPE: DVPEMobile,
    UBPE: UBPEMobile,
    LLVE: LLVEMobile,
    PLEC: PLECMobile,
    CAPA: CAPAMobile,
    IWBR: IWBRMobile,
    WIBR: WIBRMobile,
    '24MX': I2MXMobile,
    CMBR: CMBRMobile,
    VAMX: VAMXMobile
  }
};

function Logo(props) {
  const { name, height = 25, width = 'auto', mobile = false } = props;
  return (
    <img src={mobile ? source.mobile[name] : source[name]} alt='' height={height || '25'} width={width || 'auto'} />
  );
}

Logo.propTypes = {
  name: PropTypes.string.isRequired
};

export { Logo };
